import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {
    Box,
    Card,
    CardContent,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material";
import httpReq from "../services/httpReq";
import VideoComponent from "../components/asiaHome/VideoComponent";
import {Dvr, Edit, KeyboardArrowLeft, KeyboardArrowRight, SwitchVideo, VideoLibrary} from "@mui/icons-material";
import TooltipButton from "../components/buttons/TooltipButton";
import ModalEditVideo from "../components/modals/asiaEditProject/ModalEditVideo";
import FullPageLoader from "../components/loaders/FullPageLoader";
import {useLingui} from "@lingui/react";
import useMobile from "../hooks/useMobile";
import * as lod from "lodash";

const EditProjectPage = () => {
    const isMobile = useMobile();

    const {projectId, videoId, reportId} = useParams();
    const [project, setProject] = useState(null);
    const [video, setVideo] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoToEdit, setVideoToEdit] = useState(null);
    const [mapStyle, setMapStyle] = useState('openstreetmap')
    const [isLoading, setIsLoading] = useState(false);
    const mapKey = process.env.REACT_APP_API_KEY
    const [videoListCollapsed, setVideoListCollapsed] = useState(false);

    const {_} = useLingui();

    useEffect(() => {
        setIsLoading(true);
        httpReq('Project/Get/' + projectId, 'GET', null, true).then((res) => {
            if(!res || res.responseAnyError) return;
            const respData = {...res.responseData}
            setProject(respData)
        })

    }, [projectId, videoToEdit]);

    useEffect(() => {
        if(!project) return
        httpReq('Video/GetListByProject/' + project.id, 'GET', null, true).then((res) => {
            if(!res || res.responseAnyError) return;
            const respData = [...res.responseData];
            const v = lod.orderBy(respData, ['title'], 'asc');
            setVideo(v);
            if (videoId) {
                const foundedVideo = v.find(video => {
                    return video.id === +videoId;
                })
                setSelectedVideo(foundedVideo)
            }
        })
        setIsLoading(false);
    }, [project, videoId, videoToEdit]);

    const VideoList = () => {
        return (
            <Card sx={{
                borderRadius: 4,
                boxShadow: 3,
                bgcolor: 'background.default',
                width: '100%',
                height: '100%',
                borderRight: '1px solid lightray',
                overflowY: 'auto',
                mt: 2
            }}>
                <CardContent>
                    {/* Header */}
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: '40px' }}>
                        <Typography variant="h6" sx={{fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 4}}>
                            <Dvr/> {project?.name}
                        </Typography>
                        <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1}}>
                            <IconButton onClick={() => setVideoListCollapsed(true)}><KeyboardArrowLeft color="action"/></IconButton>
                        </Box>
                    </Box>
                    <Divider sx={{mb: 2}}/>
                    {/* Video Items */}
                    <List sx={{p: 0}}>
                        {video && video.map((video) => (
                            <ListItem
                                key={video.id}
                                selected={selectedVideo?.id === video.id}
                                sx={{borderRadius: 2, transition: '0.2s'}}
                            >
                                <ListItemIcon>
                                    <VideoLibrary color={selectedVideo?.id === video.id ? 'primary' : 'action'}/>
                                </ListItemIcon>
                                <ListItemText
                                    primary={video.title}
                                    primaryTypographyProps={{
                                        fontSize:13,
                                        fontWeight: selectedVideo?.id === video.id ? 'bold' : 'normal',
                                    }}
                                />
                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                    <TooltipButton action={() => setVideoToEdit(video)} icon={<Edit/>} title={`Edit ${video.title}`}/>
                                    <TooltipButton action={() => { setSelectedVideo(video); setVideoListCollapsed(true); }} icon={<SwitchVideo/>} title={`Open ${video.title}`}/>
                                </Box>
                            </ListItem>
                        ))}
                    </List>
                </CardContent>
            </Card>
        )
    }

    return (
        <>
            <Box sx={{ display: 'flex', gap: 1 }}>
                {videoListCollapsed && (
                    <Box
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{
                            borderRadius: 4,
                            boxShadow: 3,
                            bgcolor: 'background.default',
                            position: 'absolute',
                            left: 5,
                            top: 75,
                            width: '50px',
                            height: '50px'
                        }}
                    >
                        <IconButton onClick={() => setVideoListCollapsed(false)}>
                            <KeyboardArrowRight color="action" fontSize={'large'}/>
                        </IconButton>
                    </Box>
                )}
                {!videoListCollapsed && (
                    <Box
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{width: '20vw', height: '90vh'}}
                    >
                        <VideoList/>
                    </Box>
                )}
                {selectedVideo && (
                    <Box
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{
                            ml: videoListCollapsed ? 1 : 0,
                            width: videoListCollapsed ? '99vw' : '79vw',
                            height: '90vh'
                        }}
                    >
                        <VideoComponent reportId={reportId} selectedVideo={selectedVideo} mapKey={mapKey} setMapStyle={setMapStyle} mapStyle={mapStyle} isMobile={isMobile}/>
                    </Box>
                )}
            </Box>
            {videoToEdit && <ModalEditVideo setVideo={setVideoToEdit} video={videoToEdit}/>}
            {isLoading && <FullPageLoader/>}
        </>
    )

}
export default EditProjectPage